export const PAGES = {
  mentions_legales: {
    titre: 'MENTIONS LÉGALES',
    description: `Edité par Cityzeum SAS
    <br\>
    Siège : 38 rue des Mathurins 75008 PARIS  (fermé au public)
    <br\>
    SIRET : 489488817, RCS Paris
    <br\>
    Hébergeur : OVH 2 rue Kellermann – BP 80157 59053 ROUBAIX CEDEX 1  et http://www.1and1.fr/
    <br\>
    TVA : FR50489488817
    <br\>
    Responsable de la publication :  julien Laz
    <br\>
    Email :info@cityzeum.com
    <br\>
    Ce site utilise des cookies à des fins marketing, d'analyse d'audience, légales, de bon fonctionnement, d'amélioration du service et de sécurité de nos systèmes
    <br\>
    Si vous renoncez à les acceptez, sécurisez votre navigateur pour les refuser ou quittez ce site
    <br\>
    Mentions légales et politique de confidentialité de Cityzeum SAS : <a href='https://www.cityzeum.com/ar/mentions-legales' target='_blank'>voir le détail</a>`,
    paragraphes: [],
  },
  a_propos: {
    titre: 'A propos',
    description: ``,
    paragraphes: [
      {
        titre: 'Le concept : Ailleurs, maintenant!',
        description: `
        <p>Sechapper.com est la première place de marché multi-thématiques francophone qui permet de s'inspirer et dénicher la perle parmi des millions d'offres de voyages et loisirs (environ 3 millions). Elle agrège les offres des principaux site marchands, une cinquantaine, dans le domaine de l'hébergement (hôtel, camping, B&B, location, entre particuliers...), des activités (sites touristiques, tours, visites guidées,...), des ventes privées, des transports (vol, train, taxi, parking, transports en commun, croisière...) et des agences de voyages (réceptif, voyage sur mesure, séjour packagé, safari, voyage de noces, tour opérateur...)</p>
        <h3 class="h3titre">#1  GET INSPIRED :</h3>
        <p>Une interface inspirante, sociale, sémantique & riche du plus grand catalogue de produits et services de voyage. En ligne, ce sont plus de 2 millions de produits hôtels, vols, locations, loisirs, activités, séjours, camping, sur-mesure,voiture…</p>
        <h3 class="h3titre">#2  BUY :</h3>
        <p>Des produits finement catégorisés par thème, destination & mot clef, permettant une recherche ciblée et un renvoi vers le site du voyagiste / professionnel du tourisme pour acheter la prestation directement auprès de lui.</p>
        <br>
        <br>
        <p><b>Une market place de voyages pas comme les autres :</b></p>
        <ul>
        <li>- moteur de recherche sémantique & full text…et ça, il y en a pas des masses!</li>     
        <li>- curation sociale des offres</li>
        <li>- une approche en direct des producteurs, autant que faire se peut</li>
        <li>- des milliers de deals en direct</li>
        <li>- soumission offres UGC & pro en 1 minute</li>
        <li>- smart alerts (offres, prix, deals, news..) - bientôt disponible</li>
        <li>- cartes enrichies : à voir + à faire + où dormir + où manger - bientôt disponible</li>
        </ul>
        `,
      },
      {
        titre: 'Pour la petite histoire....',
        description: `
        <p>"Comme tout le monde, j’étouffe si je ne m’évade pas régulièrement. Après un tour du monde en sac à dos, il y a 15 ans, j’en ai même fait mon métier en lançant un guide de voyage professionnel, Cityzeum.com, qui aide près de 10 millions de voyageurs tous les ans. Forcément, je passe le plus clair de mes journées sur des sites de voyage… mais dès que je prends ma casquette de voyageur, plus aucun ne me fait triper, ne me simplifie la vie, ni même ne m’inspire. J’ai cherché pendant des années une idée redonnant ses heures de gloire au “marketing de l’envie”, un concept simple, qui tiendrait sur une seule page. Un jour, ma femme m’a dit : “et pourquoi pas S’echapper.com?”. Banco, le site est né et j’adore son logo!"</p>
        <br>
        <p>Julien, fondateur de S’échapper.com</p>
        `,
      },
    ],
  },
  referencer_votre_offre: {
    titre: 'Référencer votre offre',
    description: ``,
    paragraphes: [
      {
        titre: 'Le concept : la plus grande market place voyages & loisirs',
        description: `
        <h3 class="h3titre">GET INSPIRED :</h3>
        <p>Une interface inspirante, sociale, sémantique & riche du plus grand catalogue de produits et services de voyage. En ligne, ce sont plus de 2 millions de produits hôtels, vols, locations, loisirs, activités, séjours, camping, sur-mesure,voiture… </p>
        <h3 class="h3titre">BUY :</h3>
        <p>Des produits finement catégorisés par thème, destination & mot clef, permettant une recherche ciblée et un renvoi vers le site du voyagiste / professionnel du tourisme pour acheter la prestation directement auprès de lui.</p>
        `,
      },
      {
        titre: `Nous touchons plus de 9 millions de voyageurs`,
        description: `        
        Les différents portails édités par Cityzeum attirent environ 9 millions de voyageurs par an <b>en phase de préparation de voyage et réservation</b>
        <br><br>
        <p><span class="gras">Quelques metrics:</span></p>
        <ul>
        <li>- plus de 1000 destinations en ligne et 150 000 pages de contenus uniques (à voir, à faire, pratique, où dormir, comment y aller…)</li>
        <li>- 70% mobile & tablettes   /  65% femmes   /   75% localisés en France  /  25-60 ans</li>
        <li>- 100% trafic naturel et gratuit</li>
        </ul>
        `
      },
      {
        titre:'Nos offres pour les professionnels',
        description:`        
        <p>Ce service permet d’attirer du <span class="gras">trafic qualifié, en direct et à la performance</span> en recherche de réservation de voyages et week-end.</p>
        <p>
        <span class="gras">Nous apportons:</span>
        <ul>
        <li>- Trafic, Ventes, Inspiration, Info-mediation, Branding, Recherche Full Text, curation sociale, ...</li>
        </ul>
        </p>
        <p>
        <span class="gras">Nous n’apportons pas:</span>
        <ul>
        <li>- Comparaison prix, Promo only, Intermédiaire de facturation client, Disponibilité offres</li>
        </ul>
        </p>
        <p>        
        <span class="gras">Les offres sont commercialisés au coût par clic (CPC)</span>
        <ul>        
          <li>- Agences en ligne / sites thématiques / sites voyage e-commerce (séjours / hôtels / transports / activités)
            <ul>
            <li>Pack	   150 clics -   50€ soit 0.33€ CPC</li>        
            <li>Pack 	   500 clics - 125€ soit 0.25€ CPC</li>        
            <li>Pack 	1 000 clics - 220€ soit 0.22€ CPC</li>        
            <li>Pack 	5 000 clics - 1000€ soit 0.20€ CPC</li>        
            <li>Plus de clics : nous consulter</li>
            </ul>
          </li>          
          <li>Professionnels du tourisme indépendants (hôtel / camping / activités / lieux / événements / restaurant / transport / sortie )
            <ul>
              <li>Pack  50€ : mise en ligne jusqu’au 31/12/2023</li>
            </ul>
          </li>
        </ul>
        <br><br>
        NB1 : les offres sont prépayées
        <br><br>
        NB2 : les offres qui proposent des offres spéciales exclusives par rapport au tarif public sont plus mises en avant au sein de nos services que les autres
        `
      },
      {
        titre:'Process de mise en place',
        description:`
        <p>
        Cas 1 : professionnel indépendant (soumission d’une seule offre) : Afin de référencer une seule offre (hôtel, camping, location, musée, monument, activité, restaurant, sortie…), il suffit de remplir ce formulaire ci dessous et de payer en ligne avec le lien que nous vous enverrons si votre offre est retenue. Votre offre sera désactivée en fin de période.
        <br>
        Candidater : <a href="https://forms.gle/argVoqEFW7tHfyoVA" target="_blank">https://forms.gle/argVoqEFW7tHfyoVA</a>
        </p>
        <br>
        <p>        
        Cas 2: agence de voyage en ligne / site e-commerce voyage (plusieurs offres): 
        <br>
        Nous avons juste besoin de vos données structurées de cette manière (un fichier de 5 lignes à 1 million de lignes! au format CSV ou Xml ou Excel ou Google Sheet) : Titre offre* / Url photo / Description / Tags / Prix / Url de réservation* / Date péremption  / Promo (* champs obligatoires,  pour le reste, on peut s'arranger simplement!). La mise en place peut s'effectuer en quelques minutes. Pour mettre une telle campagne en place, contactez nous
        <br>
        Candidater : <a href="https://forms.gle/CLSv4a9Raeh7LjnQ6" target="_blank">https://forms.gle/CLSv4a9Raeh7LjnQ6</a>
        </p>
        <br><br>        
        
        Remarques importantes:
        <p>
        Il est entendu que les clics sont des clics sortants comptabilisés par les dispositifs internes de tracking de Cityzeum. Cityzeum ne peut maitriser la vitesse de diffusion des clics, laissant les internautes totalement libres dans leurs recherches et dans leurs clics sur des offres, sans les influencer. Ainsi, l’écoulement du budget de clics peut s’étaler sur plusieurs mois. Les sommes facturées en amont de la campagne ne sont pas remboursables, sauf cas exceptionnel.
        </p>
        `,
      }
    ],
  },
};
